// extracted by mini-css-extract-plugin
export default {"root":"PillButton_root__cwmwP","sm":"PillButton_sm__xHIbE","md":"PillButton_md__211WF","pressed":"PillButton_pressed__-A0Vt"};